import React from 'react'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconList } from '../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'
import { Menu, MenuPurge, MenuRestore } from '../../../../shared/menu/menu'
import { useRouteMatch } from 'react-router-dom'
import { useApiListAnalyticType } from '../../../../api-new/state/analytics'
import { recycleErrorMessage } from '../../../../shared/error/server-message'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'

export const AnalyticTypeRecycle = () => {
  const { url } = useRouteMatch()

  const apiListAnalyticType = useApiListAnalyticType()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAnalyticType.get('deleted')
  const handleDestroyed = () => apiListAnalyticType.init()

  const handleRestore = async data => {
    setError(null)
    try {
      await apiListAnalyticType.put(`${data.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That analytic type was already removed.'), err)
    }
    await apiListAnalyticType.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle Bin">
        <CardFullHeightScrollY title="Recycle Bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAnalyticType} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="description" />
            <ColumnText field="analyticCount" header="Analytics" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show />
                  <MenuPurge to={`${url}/${row.id}/purge`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
